<!-- Main Sidebar Container -->
<aside class="main-sidebar sidebar-dark-primary elevation-4">
  <!-- Sidebar -->
  <div class="sidebar p-0">
    <!-- Sidebar Menu -->
    <nav class="mt-2">
      <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
        <!-- Add icons to the links using the .nav-icon class
               with font-awesome or any other icon font library -->
        <ng-container *ngFor="let menu of menuList">
          <li class="nav-item" [routerLink]="[menu.route]" class="nav-link"
            [ngClass]="{ active: selectedMenu.startsWith(menu.route) }" [ngStyle]="{
              height: navigationSevice.isExpanded ? '2.4rem' : '3.4rem'
            }">
            <a style="display: flex; align-items: center; padding-right: 0" [ngStyle]="{
                'padding-left': !navigationSevice.isExpanded ? '0px' : '',
                'justify-content': !navigationSevice.isExpanded ? 'center' : ''
              }" [title]="!navigationSevice.isExpanded ? menu.label : ''">
              <div style="flex-direction: column" [ngClass]="{ 'mini-menu-label': !navigationSevice.isExpanded }">
                <img src="{{
                    getIconPath(menu.label, selectedMenu.startsWith(menu.route))
                  }}" [ngClass]="{
                    'active-image': selectedMenu.startsWith(menu.route)
                  }" width="24px" height="24px" style="margin-left: 1px" />
                <span class="menu-label" style="font-size: 0.6rem" *ngIf="!navigationSevice.isExpanded">
                  {{ menu.label }}
                </span>
              </div>
              <span class="menu-label" *ngIf="navigationSevice.isExpanded">
                {{ menu.label }}
              </span>
            </a>
          </li>
        </ng-container>
      </ul>
    </nav>
    <!-- /.sidebar-menu -->
  </div>
  <!-- /.sidebar -->
</aside>